import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemLocationDetailFragmentDoc } from '../fragments/itemLocationDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateItemLocationMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  type?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateItemLocationMutation = { __typename?: 'Mutation', createItemLocation: { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null } };


export const CreateItemLocationDocument = gql`
    mutation CreateItemLocation($name: String!, $type: String) {
  createItemLocation(name: $name, type: $type) {
    ...ItemLocationDetail
  }
}
    ${ItemLocationDetailFragmentDoc}`;
export type CreateItemLocationMutationFn = Apollo.MutationFunction<CreateItemLocationMutation, CreateItemLocationMutationVariables>;

/**
 * __useCreateItemLocationMutation__
 *
 * To run a mutation, you first call `useCreateItemLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemLocationMutation, { data, loading, error }] = useCreateItemLocationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateItemLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemLocationMutation, CreateItemLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemLocationMutation, CreateItemLocationMutationVariables>(CreateItemLocationDocument, options);
      }
export type CreateItemLocationMutationHookResult = ReturnType<typeof useCreateItemLocationMutation>;
export type CreateItemLocationMutationResult = Apollo.MutationResult<CreateItemLocationMutation>;
export type CreateItemLocationMutationOptions = Apollo.BaseMutationOptions<CreateItemLocationMutation, CreateItemLocationMutationVariables>;